import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useHistory, useLocation } from "react-router-dom";
import { Tooltip } from "react-tippy";
import Water from "../common/WaterMark";
import generatePDF from "react-to-pdf";
import styles from "../billing/invoiceDetail.module.scss";

function BulkInvoice() {
    const targetRef = useRef();
    const history = useHistory();
    const [brands, setBrands] = useState();
    const [packages, setPackages] = useState([]);
    const [total, setTotal] = useState(0);
    const [paid, setPaid] = useState(false);
    const [show, setShow] = useState(false);
    const [notpaid, setNotPaid] = useState(false);
    const [notes, setNotes] = useState();
    const [SubTotal, setSubTotal] = useState(0);
    const [invoiceCount, setInvoiceCount] = useState(0);
    const role = localStorage.getItem("role");
    const isAdminOrClerk = role === "admin" || role === "clerk";
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    const getBrands = async () => {
        const res = JSON.parse(localStorage.getItem("Zazioaggregated"));
        const paidIds = JSON.parse(localStorage.getItem("Zaziopaid")) || [];
        setBrands(res);
        setPackages(res?.packages);
        setTotal(res?.invoiceAmount);
        setNotes(res?.notes);
        setSubTotal(res?.TotalAmount);
        setInvoiceCount(paidIds.length);
    };
    useMemo(() => {
        getBrands();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handlePdf = () => {
        if (brands?.paymentStatus === "paid") {
            generatePDF(targetRef, {
                filename: `inovice(${brands?.invoiceNo}).pdf`,
                page: { format: "A3", margin: { top: 10, right: 30, bottom: 10, left: 30 } },
            });
        } else {
            setShow(false);
            setNotPaid(true);
        }
    };

    useEffect(() => {
        if (show === false && notpaid === true) {
            generatePDF(targetRef, {
                filename: "notPaid.pdf",
                page: { format: "A3", margin: { top: 10, right: 30, bottom: 10, left: 30 } },
            });
            setShow(true);
            setNotPaid(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const handlePayment = () => {
        const aggregated = JSON.parse(localStorage.getItem("Zazioaggregated")) || {};
        localStorage.setItem("Zazioaggregated", JSON.stringify({ ...aggregated, notes }));
        localStorage.setItem("PaymentUser", isAdminOrClerk ? "admin" : "user");
        history.push(`/bulkPayment`);
    };

    const statusMeta = { label: "Pending", cls: styles.pending };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.toolbar}>
                <div className={styles.toolbarLeft}>
                    <span className={styles.invoiceNo}>Bulk Payment · {invoiceCount} invoice{invoiceCount === 1 ? "" : "s"}</span>
                    <span className={`${styles.statusBadge} ${statusMeta.cls}`}>{statusMeta.label}</span>
                </div>
                <div className={styles.toolbarActions}>
                    <Tooltip title="Download Invoice as PDF" position="bottom" trigger="mouseenter" arrow={true}>
                        <Button icon="pi pi-file-pdf" label="PDF" className={styles.actionBtn} onClick={handlePdf} />
                    </Tooltip>
                    {!paid && (
                        <Tooltip title="Pay Invoices" position="bottom" trigger="mouseenter" arrow={true}>
                            <Button icon="pi pi-wallet" label="Pay" className={`${styles.actionBtn} ${styles.actionBtnPrimary}`} onClick={handlePayment} />
                        </Tooltip>
                    )}
                </div>
            </div>

            <div className={styles.layout}>
                <div className={styles.documentColumn}>
                    <div className={styles.documentOuter} ref={targetRef}>
                        {paid && <Water />}
                        <div className={styles.paper}>
                            <div className={styles.docHeader}>
                                <img src={"https://res.cloudinary.com/dwxqg9so3/image/upload/w_500,q_auto:best,f_auto,dpr_2.0/v1758208458/4wd_logo_white_duzzog.png"} className={styles.logo} alt="logo" />
                                <div className={styles.infoGrid}>
                                    <div className={styles.infoBlock}>
                                        <h4>Client Info</h4>
                                        <span>{brands?.clientName}</span>
                                        <span>{brands?.email}</span>
                                        <span>{brands?.phone}</span>
                                    </div>
                                    <div className={styles.infoBlock}>
                                        <h4>Shipping Address</h4>
                                        <p>1470 Lee Wagener Blvd, 101</p>
                                        <p>Fort Lauderdale</p>
                                        <p>FL 33315</p>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.docTitleRow}>
                                <h2 className={styles.docTitle}>{paid ? "Receipt" : "Invoice"}</h2>
                            </div>

                            <div className={styles.metaList}>
                                <div className={styles.metaRow}>
                                    <span className={styles.metaLabel}>Order Date</span>
                                    <span className={styles.metaValue}>{brands?.date}</span>
                                </div>
                                <div className={styles.metaRow}>
                                    <span className={styles.metaLabel}>Payment Method</span>
                                    <span className={styles.metaValue}>Card {brands?.datePaid ? `at ${brands?.datePaid}` : null}</span>
                                </div>
                                <div className={styles.metaRow}>
                                    <span className={styles.metaLabel}>Total Weight</span>
                                    <span className={styles.metaValue}>{brands?.weight} Lbs</span>
                                </div>
                                <div className={styles.metaRow}>
                                    <span className={styles.metaLabel}>Contents</span>
                                    <span className={styles.metaValue}>{brands?.descriptions}</span>
                                </div>
                            </div>

                            <table className={styles.table}>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Weight</th>
                                        <th>Price</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {brands?.invoiceType !== "Monthly" &&
                                        packages?.map((item, index) => {
                                            let temp;
                                            let prev = packages[index - 1]?.product;
                                            if (brands?.customerType === "client") {
                                                temp = item?.product === prev ? "Additional Pounds" : "1st Pound of Cargo";
                                            } else {
                                                temp = "Total Pounds of Cargo";
                                            }
                                            return (
                                                <tr className={styles.row} key={item?._id || index}>
                                                    <td>{temp}</td>
                                                    <td>{item?.weight} lb</td>
                                                    <td>${item?.price}</td>
                                                    <td>${(item?.total).toFixed(2)}</td>
                                                </tr>
                                            );
                                        })}

                                    {/* This batch may include additional invoices (a late charge like
                                        customs duty billed separately from its parent's package) - those
                                        never carry real shipped weight, so their charges are listed here
                                        by name instead of folded into the package rows above. */}
                                    {brands?.additionalCharges?.map((charge, index) => (
                                        <tr className={styles.row} key={`additional-${index}`}>
                                            <td>{charge.label}</td>
                                            <td></td>
                                            <td></td>
                                            <td>${Number(charge.amount).toFixed(2)}</td>
                                        </tr>
                                    ))}

                                    {brands?.purchaseItems?.map((item, index) => (
                                        <tr className={styles.row} key={`purchase-${index}`}>
                                            <td>
                                                {item.description}
                                                {item.quantity > 1 ? ` x${item.quantity}` : ""}
                                            </td>
                                            <td></td>
                                            <td>${Number(item.unitPrice).toFixed(2)}</td>
                                            <td>${(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)}</td>
                                        </tr>
                                    ))}

                                    {brands?.purchaseShipping > 0 && (
                                        <tr className={styles.row}>
                                            <td>Merchant Shipping</td>
                                            <td></td>
                                            <td></td>
                                            <td>${Number(brands.purchaseShipping).toFixed(2)}</td>
                                        </tr>
                                    )}
                                    {brands?.purchaseTax > 0 && (
                                        <tr className={styles.row}>
                                            <td>Tax</td>
                                            <td></td>
                                            <td></td>
                                            <td>${Number(brands.purchaseTax).toFixed(2)}</td>
                                        </tr>
                                    )}

                                    {brands?.invoiceType !== "Monthly" && brands?.itemsPrice !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Cost of Goods</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.itemsPrice}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.oversizeFee !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Oversize Fee</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.oversizeFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.packagingFee !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Packaging</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.packagingFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.pickupFee !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Pickup</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.pickupFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.deliveryFee !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Delivery</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.deliveryFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.handling !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Handling</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.handling}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.insurance !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Insurance</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.insurance}</td>
                                        </tr>
                                    )}
                                    {!show && brands?.invoiceType !== "Monthly" && brands?.declarationFee !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Declaration Fee</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.declarationFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType !== "Monthly" && brands?.customDuties !== 0 && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Custom Duties</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.customDuties}</td>
                                        </tr>
                                    )}
                                    {brands?.dangerousItemFee !== 0 && brands?.invoiceType !== "Monthly" && (
                                        <tr className={styles.row}>
                                            <td className={styles.addOnLabelCell}>Dangerous Item Fee</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.dangerousItemFee}</td>
                                        </tr>
                                    )}
                                    {brands?.invoiceType === "Monthly" && (
                                        <tr className={styles.row}>
                                            <td>Monthly Fee</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.MonthlyFee}</td>
                                        </tr>
                                    )}
                                    {!show && brands?.invoiceType === "Monthly" && (
                                        <tr className={styles.row}>
                                            <td>Website usage Fee</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.WebsiteFee}</td>
                                        </tr>
                                    )}

                                    <tr className={`${styles.row} ${styles.subtotalRow}`}>
                                        <td>Sub-Total</td>
                                        <td></td>
                                        <td></td>
                                        <td>${brands?.customerType === "partner" || brands?.customerType === "admin" ? SubTotal.toFixed(2) : total.toFixed(2)}</td>
                                    </tr>
                                    {brands?.customerType === "partner" ||
                                        (brands?.customerType === "admin" && (
                                            <tr className={styles.row}>
                                                <td>{brands?.customerType === "partner" ? "Credit Discount" : "Admin Discount"}</td>
                                                <td></td>
                                                <td></td>
                                                <td>- ${brands?.discountedAmount}</td>
                                            </tr>
                                        ))}

                                    <tr className={styles.row}>
                                        <td>Tax</td>
                                        <td></td>
                                        <td></td>
                                        <td>$0</td>
                                    </tr>

                                    {brands?.paymentStatus === "pending" && !(brands?.paidAmount > 0) ? (
                                        <tr className={`${styles.row} ${styles.totalRow}`}>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>${(brands?.invoiceAmount).toFixed(2)}</td>
                                        </tr>
                                    ) : null}
                                    {brands?.paymentStatus === "pending" && brands?.paidAmount > 0 ? (
                                        <>
                                            <tr className={styles.row}>
                                                <td>Paid Amount</td>
                                                <td></td>
                                                <td></td>
                                                <td>${(brands?.paidAmount).toFixed(2)}</td>
                                            </tr>
                                            <tr className={`${styles.row} ${styles.totalRow}`}>
                                                <td>Remaining Amount</td>
                                                <td></td>
                                                <td></td>
                                                <td>${(brands?.invoiceAmount).toFixed(2)}</td>
                                            </tr>
                                        </>
                                    ) : null}
                                    {brands?.paymentStatus === "paid" ? (
                                        <tr className={`${styles.row} ${styles.totalRow}`}>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>${(brands?.paidAmount).toFixed(2)}</td>
                                        </tr>
                                    ) : null}
                                    {!brands?.paymentStatus && (
                                        <tr className={`${styles.row} ${styles.totalRow}`}>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>${(total || 0).toFixed(2)}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div className={styles.notesSection}>
                                <p className={styles.notesTitle}>Customer Note</p>
                                <p className={styles.notesIntro}>THANK YOU for choosing Move4wd as your shipping partner! Please see your order updates below.</p>
                                <ul className={styles.notesList}>
                                    <li>Status: Preparing Package for Shipment</li>
                                    <li>Shipment: {brands?.shipmentNumber}</li>
                                    <li>Package: {brands?.Waybills}</li>
                                </ul>
                                <div className={styles.editField}>
                                    <label>Notes</label>
                                    <textarea
                                        className={styles.editTextarea}
                                        value={notes || ""}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setNotes(value);
                                            setBrands((prev) => ({ ...prev, notes: value }));
                                        }}
                                    />
                                </div>
                                <p className={styles.zipNote}> PLEASE USE 00000 for the ZIP Code when using a Jamaican Debit/Credit Card) to make payment.</p>

                                <img
                                    src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1696375833/WhatsApp_Image_2023-09-25_at_03.12.56_463150e6_ua2zka.jpg"
                                    className={styles.whatsappBanner}
                                    onClick={() => handlePayment()}
                                    alt="Pay via WhatsApp"
                                />
                                <p className={styles.footerText}>
                                    <strong>MOVE4WD</strong> is a registered corporation in Florida, United States
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BulkInvoice;
